import { render, staticRenderFns } from "./NonGTARow.vue?vue&type=template&id=50bc12f2"
import script from "./NonGTARow.vue?vue&type=script&lang=js"
export * from "./NonGTARow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports